module.exports = {

  // Change this to your firebase configuration! (Add Firebase to your web app)
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyDYQXfZPVvdBxojiVvueBa3hVZUnl0sA5o',
    authDomain: 'staza-stg.firebaseapp.com',
    databaseURL: 'https://staza-stg.firebaseio.com',
    projectId: 'staza-stg',
    storageBucket: 'staza-stg.appspot.com',
    messagingSenderId: '486840244353',
    apiUrl: 'https://us-central1-staza-stg.cloudfunctions.net',
  },

  AUTH0: {
    CLIENT_ID: 'zUKSnGl7qRWKAL6RiHmuqOhMeV1y7tID',
    DOMAIN: 'staza-stg.auth0.com',
    REDIRECT_URL: window.location.hostname === 'localhost' ? 'http://localhost:3002/callback' : 'https://staza-stg.firebaseapp.com/callback', // 'https://hub-stg.staza.io/callback',
  },

  BASE_URL: window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://staza-stg.appspot.com',

};



// WEBPACK FOOTER //
// ./src/config/index.js